<template>
    <a class="anchor" :href="url" target="_blank" v-if="url">
        <slot />
    </a>
    <router-link class="anchor" :to="target" v-else>
        <slot />
    </router-link>
</template>

<script>
    export default {
        name: 'Anchor',
        props: {
            chapter: String,
            url: String,
            hash: String
        },
        computed: {
            target(){
                const target = {name: 'chapter'};

                if(this.hash){
                    target.hash = `#${this.hash}`;
                }

                if(this.chapter){
                    target.params = {chapter: this.chapter};
                }

                return target;
            }
        }
    }
</script>

<style lang="less">
    @import "~@/assets/less/variables";


</style>
